import { Link, LinkProps } from 'react-router-dom'
import { cn } from './cn'

export function Anchor(
  props: React.DetailedHTMLProps<
    React.AnchorHTMLAttributes<HTMLAnchorElement>,
    HTMLAnchorElement
  >
) {
  return (
    <a
      className={cn(
        'text-brand-active hover:text-sage visited:text-brand-deep active:font-medium underline',
        props.className
      )}
      {...props}
    />
  )
}

export function RouterLink(props: LinkProps) {
  return (
    <Link
      className={cn(
        'text-brand-active hover:text-sage visited:text-brand-deep active:font-medium underline',
        props.className
      )}
      {...props}
    />
  )
}
